<template>
  <a-row>
    <a-form :form="form">
      <a-form-item label="用户名" 
            :label-col=  "{sm: { span: 6  }, md: { span: 5 }, lg: { span: 3 }, xl: { span: 3 }, xxl: {span: 4}}" 
            :wrapper-col="{sm: { span: 18 }, md: { span: 19}, lg: { span: 21}, xl: { span: 21}, xxl: {span: 20}}" 
            style="margin-bottom: 8px; text-align: right;">
        <a-input placeholder="用户名" v-decorator="[ 'account', {rules: [{ required: true, message: '请输入用户名！'}]} ]"/>
      </a-form-item>
      <a-form-item label="初始密码" 
            :label-col=  "{sm: { span: 6  }, md: { span: 5 }, lg: { span: 3 }, xl: { span: 3 }, xxl: {span: 4}}" 
            :wrapper-col="{sm: { span: 18 }, md: { span: 19}, lg: { span: 21}, xl: { span: 21}, xxl: {span: 20}}" 
            style="margin-bottom: 8px; text-align: right;">
        <a-input placeholder="密码" type="password" v-decorator="[ 'passwd', {rules: [{ required: true, message: '请输入密码！'}]} ]"/>
      </a-form-item>
      <a-form-item label="手机号" 
            :label-col=  "{sm: { span: 6  }, md: { span: 5 }, lg: { span: 3 }, xl: { span: 3 }, xxl: {span: 4}}" 
            :wrapper-col="{sm: { span: 18 }, md: { span: 19}, lg: { span: 21}, xl: { span: 21}, xxl: {span: 20}}" 
            style="margin-bottom: 8px; text-align: right;">
        <a-input placeholder="手机号" v-decorator="[ 'mobile', {rules: [{ required: true, message: '请输入手机号！'}]} ]"/>
      </a-form-item>
      <a-row style="margin-bottom: 8px"> 
        <a-col :xs="6" :sm="6" :md="5" :lg="3" :xl="3" :xxl="4">
          <a-form-item label="服务类型" style="margin-bottom: 8px; text-align: right;">
          </a-form-item>
        </a-col>
        <a-col :xs="24" :sm="24" :md="19" :lg="21" :xl="21" :xxl="20">
          <a-row v-for="(service, index) in price_table" :key="index" style="padding-left: 0px;">
            <a-col 
              :xs="5" :sm="4" :md="4" :lg="3" :xl="3" :xxl="4" 
              style="text-align: right; padding-right: 10px;">
              <label>{{service.name.replace("服务", "")}}</label>
            </a-col>
            <a-col 
              :xs="19" :sm="18" :md="18" :lg="21" :xl="21" :xxl="20">
              <a-radio-group :name="service.name">
                <a-tooltip placement="top" :title="showPriceDetail(index, order)" v-for="(version, order) in service.price" :key="order">
                  <a-radio :value="version.name" @click="selectedService(index, order)">{{version.name}}</a-radio>
                </a-tooltip>
              </a-radio-group>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
      <a-row>
        <a-form-item label="总费用" 
          :label-col=  "{sm: { span: 6  }, md: { span: 5 }, lg: { span: 3 }, xl: { span: 3 }, xxl: {span: 4}}" 
          style="margin-bottom: 8px;">
        </a-form-item>
      </a-row>
      <a-row style="text-align: center; font-weight:800; color: red; margin-bottom: 12px">
        <label>{{spend_all}}&nbsp;元</label>
      </a-row>
      <a-row>
        <a-form-item style="text-align: center; margin-bottom: 12px;">
          <a-button type="primary" @click="addUserForAgent">添加</a-button>
        </a-form-item>
      </a-row>
    </a-form>
  </a-row>
</template>

<script>

export default {
  name: 'Agent',
  data() {
    return {
      form: this.$form.createForm(this),
      spend: [],
      spend_all: 0.0,
      refresh: 0
    }
  },
  props: {
    uid: {
      type: String,
      default: function () {
        return ""
      }
    },
    price_table: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  components: {
  },
  methods: {
    showPriceDetail: function (index, order) {
      let text = "";
      let limit = this.price_table[index].limit;
      for (let key in limit) {
        if (limit[key][order]) {
          text += limit[key].name + "：" + limit[key][order] + limit[key].unit + "； ";
        }
      }
      text += this.price_table[index].price[order].price + "" + this.price_table[index].price[order].unit;
      return text;
    },
    selectedService: function (index, order) {
      if (!this.spend[index]) {
        this.spend[index] = {};
      }

      this.spend[index] = {
        price: this.price_table[index].price[order].price,
        service : {
          service: this.price_table[index].service,
          version: order
        }
      };

      let sum = 0.0;
      for (let i = 0; i < this.spend.length; i++) {
        if (this.spend[i] != null) {
          sum += this.spend[i].price;
        }
      }
      this.spend_all = sum;
    },
    addUserForAgent: function () {
      let e = false;
      this.form.validateFields((err, values) => {
        if (err) {
          e = true;
          return;
        }
      });
      if (e) {
        return;
      }
      if (this.spend.length == 0) {
        this.$message.error("请选择产品！");
        return;
      }
      let postdata = {
        account: this.form.getFieldValue('account'),
        passwd: this.form.getFieldValue('passwd'),
        mobile: this.form.getFieldValue('mobile'),
        task: "ADD_AGENT_USER",
        service: this.spend
      };
      let that = this;
      that.post("agent", postdata)
        .then(function(data) {
          console.log(data);
          if (data.ret == 200) {
            that.$message.success("添加成功！");
            that.spend = [];
            that.spend_all = 0.0;
            that.price_table = [];
          } else if (data.ret == 408) {
            that.$message.error("余额不足！");
          } else if (data.ret == 3003) {
            that.$message.error("请选择产品！");
          } else if (data.ret == 5001) {
            that.$message.error("该用户名已存在！");
          } else if (data.ret == 5002) {
            that.$message.error("该手机号已存在！");
          } else {
            that.$message.error("添加失败！");
          }
        }).catch(function (e) {
          console.log(e);
          that.$message.error("添加失败！");
      });
    }
  },
  created() {
  }
}
</script>

<style scoped>
  .content-container {
    border-bottom: 1px solid #e1e4e8;
    border-left: 1px solid #e1e4e8;
    border-right: 1px solid #e1e4e8;
  }
  .content-item {
    border-top: 1px solid #e1e4e8;
  }
</style>
